module.exports = __webpack_public_path__ + "static/media/plan_your_day_outside.60944d87.png";